import { render, staticRenderFns } from "./PaymentBreakdown.vue?vue&type=template&id=29e83f3c&"
import script from "./PaymentBreakdown.vue?vue&type=script&lang=js&"
export * from "./PaymentBreakdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports